<template>
<div class="image-uploader card shadow p-3">
    <div class="container p-0">
      <img v-for="(path, i) in value" class="icon-48 mr-1" :src="path" :key="i" />
      <img v-if="value.length === 0" class="icon-48 mr-1" :src="$util.asset('goobank_assets/assets/icons/new-image@2x.png')" />
    </div>
    <div class="row mt-3">
        <div class="col-md-5">
            <p class="text-secondary m-0">ตัวอย่างรูปถ่าย</p>
            <p v-if="value.length >= limit" class="text-secondary m-0">อัพโหลดรูปได้สูงสุดที่ {{limit}} รูป</p>
        </div>
        <div class="col-md-7 text-right">
            <button @click="deleteAllImages()" class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60"><span aria-hidden="true">&times;</span></button>
            <label v-if="value.length < limit" class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
              <template v-if="isUploading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              </template>
              <template v-else>อัพโหลดรูป</template>
                <input type="file" hidden="hidden" ref="inputbtn" accept="image/*" :disabled="isUploading" @change="fileAdded" />
            </label>
        </div>
        <div v-if="isCantReachWhenSubmit" class="alert alert-warning mb-0 mt-2 mr-2 ml-2">
          ไม่สามารถติดต่อเซิร์ฟเวอร์ได้ กรุณาลองอัพโหลดใหม่อีกครั้ง
        </div>
    </div>
</div>
</template>

<script>
export default {
  data: () => ({
    isCantReachWhenSubmit: false,
    isUploading: false,
  }),
  methods: {
    deleteAllImages () {
      this.updateInput([])
    },
    updateInput (newInput) {
        this.$emit('input', newInput)
    },
    async fileAdded () {
      this.isCantReachWhenSubmit = false
      this.isUploading = true
      const file = this.$refs.inputbtn.files[0]
      const bodyFormData = new FormData()
      bodyFormData.append(this.objectKey, file)
      try {
        let result;
        if (this.extraParam === '') result = await this.api(bodyFormData) // api interface
        else result = await this.api(bodyFormData, this.extraParam);
        const data = result.data

        if (!data.success) {
          console.error(result)
          this.isUploading = false
          this.isCantReachWhenSubmit = true
          return
        }
        this.updateInput(this.value.concat([data.imageURL]))
        typeof this.onDone === 'function' && this.onDone()

        this.isUploading = false
      } catch (e) {
        console.error(e)
      }
      this.$refs.inputbtn.value = ''
    }
  },
  props: {
    value: {
        type: Array,
        default: () => ([])
    },
    api: {
      type: Function,
      required: true
    },
    limit: {
      type: Number,
      default: 3
    },
    extraParam: {
      default: '',
    },
    objectKey: {
      default: 'file',
    },
    onDone: {
      default: () => {},
    },
  }
}
</script>

<style lang="scss">
</style>
